"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitterController = void 0;
const bounds_observer_1 = require("../utils/bounds-observer");
const applyBoundsOffset = (bounds, offsets = {}) => {
    const sum = (bound, offset) => {
        return bound + (offset || 0);
    };
    return {
        left: sum(bounds.left, offsets.left),
        top: sum(bounds.top, offsets.top),
        width: sum(bounds.width, offsets.width),
        height: sum(bounds.height, offsets.height)
    };
};
/**
 * Utility class for managing Golden Layout splitter drag interactions.
 * @ignore
 */
class SplitterController {
    // eslint-disable-next-line
    constructor(viewOverlay) {
        this.viewOverlay = viewOverlay;
        this.tryTeardown = () => {
            if (this.teardown) {
                this.teardown();
                this.teardown = undefined;
            }
        };
        /**
         * Disables the pointer events on the splitters, preventing them from being dragged.
         */
        this.preventSplitterResize = () => {
            document.querySelectorAll('.lm_splitter').forEach((splitter) => {
                splitter.style.pointerEvents = 'none';
            });
        };
        /**
         * Ends a splitter drag move, if one is in progress.
         */
        this.endMove = async () => {
            try {
                this.viewOverlay.detachOverlay();
                this.tryTeardown();
            }
            catch (error) {
                throw new Error(`Failed to end splitter move: ${error.stack}`);
            }
        };
        /**
         * Initialises a splitter drag move, rendering a view on top of the splitter
         * to allow it to render on top of the views within a layout (as they will always
         * have a higher z-index to the platform window itself).
         * @param splitterItem The Golden Layout splitter item that is currently being dragged.
         */
        this.startMove = async (splitterItem) => {
            try {
                if (this.teardown) {
                    console.warn('Splitter move started before other move has been torn down.');
                    this.tryTeardown();
                }
                const splitterDiv = splitterItem.element.get(0);
                const { backgroundColor } = getComputedStyle(splitterDiv);
                const initialVisibility = splitterDiv.style.visibility;
                splitterDiv.style.visibility = 'hidden';
                const onBoundsChange = (bounds) => {
                    const offsetBounds = applyBoundsOffset(bounds, { height: splitterItem.isVertical ? 0 : 2 });
                    this.viewOverlay.renderOverlay(offsetBounds);
                };
                await this.viewOverlay.setStyle({ backgroundColor });
                const teardownBoundsObserver = (0, bounds_observer_1.observeBounds)(splitterDiv, onBoundsChange);
                this.teardown = () => {
                    teardownBoundsObserver();
                    splitterDiv.style.visibility = initialVisibility;
                };
            }
            catch (error) {
                throw new Error(`Failed to start splitter move: ${error.stack}`);
            }
        };
    }
}
exports.SplitterController = SplitterController;
